module.exports = __webpack_public_path__ + "img/profile.bf08ca7e.jpg";